import { useEffect } from "react";
import { BLOG_POSTS } from "../data/blogPosts";
import { SITE_URL as SITE, absoluteUrl } from "../lib/img";

// Injects a JSON-LD script with BlogPosting entries for each of Dr. Maggie's
// articles so Google can discover and index them individually. Runs once.
export default function BlogSchema() {
  useEffect(() => {
    const graph = BLOG_POSTS.map((p) => ({
      "@type": "BlogPosting",
      "@id": `${SITE}/blog/${p.id}#article`,
      url: `${SITE}/blog/${p.id}`,
      mainEntityOfPage: { "@type": "WebPage", "@id": `${SITE}/blog/${p.id}` },
      headline: p.title,
      description: p.excerpt,
      image: absoluteUrl(p.image),
      articleSection: p.category,
      keywords: (p.categories || [p.category]).join(", "),
      author: {
        "@type": "Person",
        name: "Maggie Cadet, MD",
        url: SITE,
      },
      publisher: {
        "@type": "Person",
        name: "Maggie Cadet, MD",
        url: SITE,
      },
      inLanguage: "en-US",
    }));

    const data = {
      "@context": "https://schema.org",
      "@graph": graph,
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-testid", "blog-schema");
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}
